

import EditBase from "./EditBase"

class EditRectangle extends EditBase {

    constructor(options) {
        super(options);
    }

    initProperty() {
        var $this = this;
        var coordinatesProperty = new $this.Cesium.CallbackProperty(function () {
            var coordinates = $this.Cesium.Rectangle.fromCartesianArray($this.plot.attrPlot[EditBase.ext_positions]);
            return coordinates;
        }, false)
        this.plot.rectangle.coordinates = coordinatesProperty;
    }

    //关键点整体旋转
    rotationAll(position) {
        var $this = this;
        var PA = this.plot.attrPlot['startPoint'];
        var center = this.plot.attrPlot['centerPos'];
        var angle = this.getAngleCenterPointDir(center, position, PA) + this.rotation.startRotation;
        if (isNaN(angle)) {
            return;
        }
        let theta = angle * (180 / Math.PI);
        this.plot.rectangle.rotation = angle;
        this.plot.rectangle.stRotation = angle;
        var newPos = this.getRotateCenterPoint(center, PA, -theta);
        this.rotation.position.setValue(newPos); //更新旋转点
        // var positions = this.plot.attrPlot[EditBase.ext_positions];
        // var positions_copy = this.plot.attrPlot[EditBase.ext_positionsCopy]
        // for (let i = 0; i < positions_copy.length; i++) {
        //     var p = positions_copy[i];
        //     var newPos = this.getRotateCenterPoint(center, p, -theta);
        //     //positions[i] = newPos;
        //     $this.plot.attrPlot[EditBase.ext_keyPos][i].position.setValue(newPos);
        // }
    }

    // mouseMove(evt) {
    //     var $this = this;
    //     //关键点
    //     if (this.pick) {
    //         var cartesian = this.getCatesian3FromPX(evt.endPosition);
    //         var i = this.pick.attrPlot.e_index;
    //         $this.plot.attrPlot[EditBase.ext_positions].splice(i, 1, cartesian);
    //         this.pick.position.setValue(cartesian);
    //         this.updateCenter();
    //         this.updateRotate();
    //     }

    //     //中心点
    //     if (this.center) {
    //         var cartesian = this.getCatesian3FromPX(evt.endPosition);
    //         this.center.position.setValue(cartesian);
    //         this.translateAll(cartesian);
    //         this.updateRotate();
    //     }

    //     //旋转点
    //     if (this.rotation) {
    //         var cartesian = this.getCatesian3FromPX(evt.endPosition);
    //         this.rotation.position.setValue(cartesian);
    //         this.rotationAll(cartesian);
    //     }
    // }

    // leftClick(evt) {
    //     this.hideEdit();
    //     let pick = this.viewer.scene.pick(evt.position);
    //     var entity = this.getPickEnity(pick);
    //     if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
    //         this.showEdit();
    //     }
    // }
    // leftDown(evt) {
    //     this.pick = undefined;
    //     this.center = undefined;//中心点
    //     this.rotation = undefined;//旋转点
    //     let pick = this.viewer.scene.pick(evt.position);
    //     var entity = this.getPickEnity(pick);
    //     if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_keyFlag] && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
    //         this.pick = entity;
    //         this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
    //     }

    //     if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_centerFlag] && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
    //         this.center = entity;
    //         this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
    //     }
    //     if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_rotationFlag] && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
    //         this.rotation = entity;
    //         this.rotation.startPoint = entity.position.getValue();
    //         this.rotation.startRotation = this.plot.rectangle.rotation;
    //         this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
    //     }
    // }

    // leftUp(evt) {
    //     this.pick = undefined;
    //     this.rotation = undefined;
    //     this.center = undefined;//中心点
    //     this.positionMove = undefined;
    //     this.viewer.scene.screenSpaceCameraController.enableRotate = true;//解锁相机
    // }
}

export default EditRectangle